import React, { useState } from 'react';
import { Link, NavLink as RouterNavLink, Outlet } from 'react-router-dom';
import { useDarkMode } from '../../contexts/DarkModeContext';
// 수정된 아이콘 임포트
import { MenuIcon, LogOutIcon, ImageIcon, MessageSquareIcon, LayoutDashboardIcon, SunIcon, MoonIcon } from '../Icons';
import logo from '../../assets/logo.png';

const AdminLayout = ({ onLogout }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { darkMode, toggleDarkMode } = useDarkMode(); 

  // 아이콘 수정
  const adminNavItems = [
    { path: 'dashboard', label: '대시보드', icon: <LayoutDashboardIcon /> }, // HomeIcon -> LayoutDashboardIcon
    { path: 'images', label: '이미지 관리', icon: <ImageIcon /> }, 
    { path: 'inquiries', label: '문의 관리', icon: <MessageSquareIcon /> }, 
  ];

  return (
    <>
      <title>관리자 페이지 - 진양건설</title>
      <meta name="robots" content="noindex, nofollow" />
      <div className={`flex h-screen bg-slate-100 dark:bg-slate-900`}>
        <div className={`fixed inset-y-0 left-0 transform ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'} md:translate-x-0 md:static md:inset-0 w-64 bg-white dark:bg-slate-800 shadow-lg transition-transform duration-300 ease-in-out z-40`}>
          <div className="flex items-center justify-center h-20 border-b dark:border-slate-700">
            <Link to="/admin/dashboard" className="flex items-center space-x-2">
              <img className="h-8 w-8 text-sky-600 dark:text-sky-400" src={logo} />
              <span className="text-xl font-bold text-gray-800 dark:text-white">관리자</span>
            </Link>
          </div>
          <nav className="mt-6 px-3">
            {adminNavItems.map(item => (
              <RouterNavLink key={item.path} to={item.path} onClick={() => setSidebarOpen(false)} className={({ isActive }) => `flex items-center px-3 py-3 my-1 rounded-md text-sm font-medium transition-colors group ${isActive ? 'bg-sky-100 dark:bg-sky-700 text-sky-700 dark:text-white' : 'text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-slate-700 hover:text-gray-900 dark:hover:text-white'}`}>
                {React.cloneElement(item.icon, { className: `mr-3 h-5 w-5 flex-shrink-0 ${ 'text-gray-500 dark:text-gray-400 group-hover:text-gray-700 dark:group-hover:text-gray-200'}`})}
                {item.label}
              </RouterNavLink>
            ))}
          </nav>
        </div>
        <div className="flex-1 flex flex-col overflow-hidden">
          <header className="flex items-center justify-between h-16 bg-white dark:bg-slate-800 shadow-sm px-4 sm:px-6 lg:px-8 border-b dark:border-slate-700">
            <button onClick={() => setSidebarOpen(true)} className="md:hidden text-gray-500 dark:text-gray-400"><MenuIcon /></button>
            <div className="flex-1"></div>
            <div className="flex items-center space-x-4">
               <button onClick={toggleDarkMode} className="p-2 rounded-full text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-slate-700 transition-colors" aria-label="Toggle dark mode">
                  {darkMode ? <SunIcon className="w-5 h-5" /> : <MoonIcon className="w-5 h-5" />}
                </button>
              <button onClick={onLogout} className="flex items-center text-sm font-medium text-gray-600 dark:text-gray-300 hover:text-sky-600 dark:hover:text-sky-400 transition-colors"><LogOutIcon className="mr-1.5 h-5 w-5" />로그아웃</button>
            </div>
          </header>
          <main className="flex-1 overflow-y-auto p-6 md:p-8"><Outlet /></main>
        </div>
         {sidebarOpen && (<div className="fixed inset-0 z-30 bg-black/30 md:hidden" onClick={() => setSidebarOpen(false)}></div>)}
      </div>
    </>
  );
};

export default AdminLayout;
